import { Row, Col } from "react-bootstrap";
import "./css/Description.css";
import { IEditDocumentDescriptionProps } from "./EditDocumentInterfaces";
import { Component, useEffect } from "react";
import { useProductCompanies } from "../../api/simDocuments/ProductCompanyService";
import { ComponentStruct } from "../../common/Interfaces";

export default function EditDocumentDescription({
  document,
}: IEditDocumentDescriptionProps) {
  return (
    <div className={"grey-container"}>
      {document.productCompany && (
        <Row>
          <Col xs={2}> Product Company :</Col>
          <Col>
            <label> {document.productCompany}</label>
          </Col>
        </Row>
      )}
      {document.productRange && (
        <Row>
          <Col xs={2}>
            <label>Product Range :</label>
          </Col>
          <Col>
            <label>{document.productRange}</label>
          </Col>
        </Row>
      )}
      {document.models && document.models[0] && (
        <Row>
          <Col xs={2}>
            <label>Model :</label>
          </Col>
          <Col>
            <label>
              <label key={document.models[0].code}>
                {document.models[0].code}
              </label>
              {document.models
                .slice(1)
                .map((model: { code: string; description: string }) => (
                  <label key={model.code}>, {model.code}</label>
                ))}
            </label>
          </Col>
        </Row>
      )}
      {document.productNumbers && document.productNumbers[0] && (
        <Row>
          <Col xs={2}>
            <label>Product Number :</label>
          </Col>
          <Col>
            <label>
              <label key={document.productNumbers[0]}>
                {document.productNumbers[0]}
              </label>
              {document.productNumbers.slice(1).map((productNumbers) => (
                <label key={productNumbers}>, {productNumbers}</label>
              ))}
            </label>
          </Col>
        </Row>
      )}
      {document.serialNumber && (
        <Row>
          <Col xs={2}>
            <label>Serial Number :</label>
          </Col>
          <Col>
            {document.serialNumber && <label>{document.serialNumber}</label>}
          </Col>
        </Row>
      )}
    </div>
  );
}
